import {useMount} from '../../../../hooks/useMount';
import {handleAxiosError} from '../../../../util/http';
import {CenteredSpinner} from '../../../../components/util/widgets/CenteredSpinner/CenteredSpinner';
import {CenteredErrorMessage} from '../../../../components/util/widgets/CenteredErrorMessage/CenteredErrorMessage';
import {bindActionCreators, Dispatch} from 'redux';
import {CommonState} from '../../../../redux';
import React, {useState} from 'react';
import {AxiosError} from 'axios';
import {connect} from 'react-redux';
import InventoryGrid from './components/InventoryGrid';
import {loadInventoryManagementData} from '../../../../redux/stateResponses/inventoryManagement';

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

function InventoryManagement(props: Props) {
  const {actions: {loadInventoryData}} = props;
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  useMount(async () => {
    try {
      await loadInventoryData();
    } catch (e: AxiosError | any) {
      setErrorMessage(handleAxiosError(e, {connectionMsg: 'Failed to load inventory'}));
    }
    setLoading(false);
  });

  return loading ?  <CenteredSpinner/> : (errorMessage ? <CenteredErrorMessage message={errorMessage} /> : <InventoryGrid/>);
}

const mapDispatchToProps = (dispatch: Dispatch) => ({actions: bindActionCreators({
    loadInventoryData: loadInventoryManagementData
  }, dispatch)});
const mapStateToProps = (state: CommonState) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(InventoryManagement);
